import React from 'react';

const LambrequinSelector = ({
  lambrequin,
  setLambrequin,
  lambrequinOptions,
  isDoublePente,
  isLambrequinSeul
}) => {
  return (
    <div>
      <h3 className="text-lg font-medium mb-3">
        {isLambrequinSeul 
          ? "Type de coupe du lambrequin"
          : isDoublePente 
            ? "Souhaitez-vous les deux lambrequins ?" 
            : "Souhaitez-vous un lambrequin ?"}
      </h3>
      
      <div className="mb-4">
        <div className="grid grid-cols-4 gap-3">
          {lambrequinOptions.map((option) => (
            <button
              key={option.id}
              onClick={() => setLambrequin(option.id)}
              className={`p-4 border-2 rounded-lg text-center transition-all ${
                lambrequin === option.id
                  ? 'border-celadon bg-celadon text-white'
                  : 'border-gray-200 hover:border-gray-300'
              }`}
            >
              {option.image ? (
                <img 
                  src={option.image} 
                  alt={option.label}
                  className="w-20 h-20 mx-auto mb-2 object-contain"
                />
              ) : (
                <div className="w-20 h-20 mx-auto mb-2 flex items-center justify-center text-4xl">
                  ⊘
                </div>
              )}
              <p className="text-sm font-medium">{option.label}</p>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LambrequinSelector;